namespace RedBullMOBILE360.Sms {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.Sms.WhiteListDialog')
    export class WhiteListDialog extends Serenity.EntityDialog<WhiteListRow, any> {
        protected getFormKey() { return WhiteListForm.formKey; }
        protected getIdProperty() { return WhiteListRow.idProperty; }
        protected getLocalTextPrefix() { return WhiteListRow.localTextPrefix; }
        protected getNameProperty() { return WhiteListRow.nameProperty; }
        protected getService() { return WhiteListService.baseUrl; }
        protected getDeletePermission() { return WhiteListRow.deletePermission; }
        protected getInsertPermission() { return WhiteListRow.insertPermission; }
        protected getUpdatePermission() { return WhiteListRow.updatePermission; }

        protected form = new WhiteListForm(this.idPrefix);
    }
}